import { useEffect, useState } from 'react';

type DebounceResult<T> = {
  isPending: boolean;
  value: T;
};

const useDebounce = <T>(
  value: T,
  delay: number,
  trackPending: boolean = false,
): DebounceResult<T> => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const [isPending, setIsPending] = useState(false);

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(value), delay);

    return () => clearTimeout(handler);
  }, [value, delay]);

  useEffect(() => {
    if (!trackPending) return;

    setIsPending(true);

    const handler = setTimeout(() => {
      setIsPending(false);
    }, delay);

    return () => clearTimeout(handler);
  }, [trackPending, value, delay]);

  return {
    isPending,
    value: debouncedValue,
  };
};

export default useDebounce;
